/**
 * errorMap.js
 *
 * Vietnamese copy for playback_ack/playback_done error `message` values.
 * Ported verbatim from the mock FE's ERROR_UI table (the owner has been
 * reading these exact strings) — PLAYBACK-HANDOFF.md §4.3:
 * "copy it verbatim, the Vietnamese strings there are the ones the owner
 * has been reading."
 *
 * Detecting "this is an error" is ALWAYS done via `status === 'error'`
 * (handoff §4.3: "key on status, never on message text") — this table only
 * supplies copy for a KNOWN message; an unknown one still renders
 * (prefixed "Lỗi:"), it is never dropped.
 */
export const ERROR_UI = {
  'recordings disabled': 'Thiết bị chưa cấu hình xem lại (không phải lỗi người dùng)',
  'not found': 'Không tìm thấy đoạn ghi ở vị trí này — vui lòng làm mới danh sách',
  'stale slot': 'Danh sách đã cũ (slot đã bị ghi đè) — vui lòng làm mới danh sách',
  busy: 'Thiết bị đang tải lên đoạn khác — vui lòng đợi',
  preempting: 'Đang dừng phiên tải đang chạy để nhường cho đoạn này…',
  'storage unavailable': 'Cảnh báo thiết bị: thẻ nhớ không gắn được',
};

export function mapErrorMessage(message) {
  if (message == null) return 'Lỗi không xác định';
  if (ERROR_UI[message]) return ERROR_UI[message];
  if (message.indexOf('device not connected') === 0) return 'Thiết bị hiện không kết nối signaling';
  return 'Lỗi: ' + message;
}

/**
 * `audio strip unsupported` / `device serial invalid` (handoff §4.3): device
 * config/firmware faults — never retry. `upload failed`: transient — retry
 * is fine. Neither is `preempting` or `busy`, so callers must key retry
 * eligibility on the raw `message`, never on whether ERROR_UI has an entry
 * for it.
 */
export function isNeverRetryMessage(message) {
  return message === 'audio strip unsupported' || message === 'device serial invalid';
}
